import { ActionButton } from '../../../components/vertical-dot/popper';

export const BrokerAttestationAuditLogHeader = ({
  actions,
  tableActions,
}: {
  actions?: any[];
  tableActions: any[];
}): any[] => {
  return [
    ...(actions ?? []),
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      center: true,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row?.original?.termsAndConditionsId}
              rowData={row?.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];
};
